import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'environments/environment';
@Injectable({
  providedIn: 'root',
})
export class ApiService {
  public apiUrl = environment.url;

  constructor(private http: HttpClient) {}

  public get<T>(endpoint: string, params?: any): Observable<T> {
    const url = `${this.apiUrl}${endpoint}`;
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${localStorage.getItem('access_token')}`
    );
    headers.set('Accept', 'application/json');
    return this.http.get<T>(url, { params: params, headers: headers }).pipe(
      map((data) => data),
      catchError(this.handleError)
    );
  }

  public post<T>(endpoint: string, body: any, params?: any): Observable<T> {
    const url = `${this.apiUrl}${endpoint}`;
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${localStorage.getItem('access_token')}`
    );
    return this.http
      .post<T>(url, body, { params: params, headers: headers })
      .pipe(
        map((data) => data),
        catchError(this.handleError)
      );
  }

   public postWithHeaders<T>(endpoint: string, body: any, params?: any): Observable<T> {
     const url = `${this.apiUrl}${endpoint}`;
  let headers = new HttpHeaders()
    .set('Authorization', `Bearer ${localStorage.getItem('access_token')}`)
    .set('Content-Type', 'application/json'); // ✅ add this line

  return this.http.post<T>(url, body, { params, headers }).pipe(
    map((data) => data),
    catchError(this.handleError)
  );
  }

  public postWithoutAuth<T>(
    endpoint: string,
    body: any,
    params?: any
  ): Observable<T> {
    const url = `${this.apiUrl}${endpoint}`;
    const headers = new HttpHeaders().set('Accept', 'application/json');
    return this.http
      .post<T>(url, body, { params: params, headers: headers })
      .pipe(
        map((data) => data),
        catchError(this.handleError)
      );
  }

  public put<T>(endpoint: string, body: any, params?: any): Observable<T> {
    const url = `${this.apiUrl}${endpoint}`;
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${localStorage.getItem('access_token')}`
    );
    return this.http
      .put<T>(url, body, { params: params, headers: headers })
      .pipe(
        map((data) => data),
        catchError(this.handleError)
      );
  }

  public patch<T>(endpoint: string, body: any, params?: any): Observable<T> {
    const url = `${this.apiUrl}${endpoint}`;
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${localStorage.getItem('access_token')}`
    );
    return this.http
      .patch<T>(url, body, { params: params, headers: headers })
      .pipe(
        map((data) => data),
        catchError(this.handleError)
      );
  }

  public delete<T>(endpoint: string, params?: any): Observable<T> {
    const url = `${this.apiUrl}${endpoint}`;
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${localStorage.getItem('access_token')}`
    );
    return this.http.delete<T>(url, { params: params, headers: headers }).pipe(
      map((data) => data),
      catchError(this.handleError)
    );
  }

  private handleError(error: any): Observable<any> {
    return throwError(error);
  }
}
